/**
 * TanStack Query hooks for `igaming-scheduled-bi-warehouse-exports-etl`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingScheduledBiWarehouseExportsEtlQueryKeys,
	type CreateIgamingScheduledBiWarehouseExportsEtlBody,
	type ListIgamingScheduledBiWarehouseExportsEtlResponse,
	type IgamingScheduledBiWarehouseExportsEtlRow,
} from "./api";

export function useIgamingScheduledBiWarehouseExportsEtlList(): UseQueryResult<ListIgamingScheduledBiWarehouseExportsEtlResponse, Error> {
	return useQuery({
		queryKey: igamingScheduledBiWarehouseExportsEtlQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingScheduledBiWarehouseExportsEtlCreate(): UseMutationResult<IgamingScheduledBiWarehouseExportsEtlRow, Error, CreateIgamingScheduledBiWarehouseExportsEtlBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingScheduledBiWarehouseExportsEtlQueryKeys.all });
		},
	});
}

export function useIgamingScheduledBiWarehouseExportsEtlDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingScheduledBiWarehouseExportsEtlQueryKeys.all });
		},
	});
}
